
import { useTranslation, Trans } from "react-i18next";

import w1 from '../../img/TradingTools/w1.png';
import w2 from '../../img/TradingTools/w2.png';
import w3 from '../../img/TradingTools/w3.png';
import w4 from '../../img/TradingTools/w4.png';

import React, { useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import b1 from "../../img/Home/back.svg";
import b2 from "../../img/Home/next.svg";

const data = [
    {
        img: w1,
        title: 'trading.21',
        text: 'trading.22',
    },
    {
        img: w2,
        title: 'trading.23',
        text: 'trading.24',
    },
    {
        img: w3,
        title: 'trading.25',
        text: 'trading.26',
    },
    {
        img: w4,
        title: 'trading.27',
        text: 'trading.28',
    }
]

function WhatToTrade() {

  const { t } = useTranslation();

  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const paginationRef = useRef(null);

  return (
    <div className="relative pt-[80px] xl:pt-[160px] overflow-hidden">
        <div className="max-w-[1220px] mx-[20px] xl:mx-auto">
            <p className="zen-dots leading-[1.2] text-[24px] xl:text-[36px] text-[#1E1C21] xl:max-w-[482px]">
                <Trans>{t("trading.20")}</Trans>
            </p>
            <div className="xl:flex hidden h-[308px] mt-[40px]">
                <div className="bg-white border-t border-l border-b border-[#00000033] w-full flex flex-col">
                    <p className="zen-dots text-[16px] xl:text-[20px] text-[#1E1C21] pt-[40px] pl-[20px] pr-[35px]">{t('trading.21')}</p>
                    <p className="text-[12px] xl:text-[14px] ibm-plex text-[#000000B2] mt-[20px] pl-[20px] pr-[35px]">{t('trading.22')}</p>
                    <div className="mt-auto py-[20px] pl-[20px] border-t border-[#00000033] h-[72px]">
                        <img src={w1} alt="" />
                    </div>
                </div>
                <div className="bg-white border-t border-l border-b border-[#00000033] w-full flex flex-col">
                    <p className="zen-dots text-[16px] xl:text-[20px] text-[#1E1C21] pt-[40px] pl-[20px] pr-[35px]">{t('trading.23')}</p>
                    <p className="text-[12px] xl:text-[14px] ibm-plex text-[#000000B2] mt-[20px] pl-[20px] pr-[35px]">{t('trading.24')}</p>
                    <div className="mt-auto py-[20px] pl-[20px] border-t border-[#00000033] h-[72px]">
                        <img src={w2} alt="" />
                    </div>
                </div>
                <div className="bg-white border-t border-l border-b border-[#00000033] w-full flex flex-col">
                    <p className="zen-dots text-[16px] xl:text-[20px] text-[#1E1C21] pt-[40px] pl-[20px] pr-[35px]">{t('trading.25')}</p>
                    <p className="text-[12px] xl:text-[14px] ibm-plex text-[#000000B2] mt-[20px] pl-[20px] pr-[35px]">{t('trading.26')}</p>
                    <div className="mt-auto py-[20px] pl-[20px] border-t border-[#00000033] h-[72px]">
                        <img src={w3} alt="" />
                    </div>
                </div>
                <div className="bg-white border border-[#00000033] w-full flex flex-col">
                    <p className="zen-dots text-[16px] xl:text-[20px] text-[#1E1C21] pt-[40px] pl-[20px] pr-[35px]">{t('trading.27')}</p>
                    <p className="text-[12px] xl:text-[14px] ibm-plex text-[#000000B2] mt-[20px] pl-[20px] pr-[35px]">{t('trading.28')}</p>
                    <div className="mt-auto py-[20px] pl-[20px] border-t border-[#00000033] h-[72px]">
                        <img src={w4} alt="" />
                    </div>
                </div>
            </div>
            <div className="flex flex-col justify-between xl:hidden">
            <div className="mt-[30px] xl:w-[497px] h-[280px] bg-[#FFFFFF] border border-[#00000033] relative flex flex-col">
              <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                loop={true}
                autoplay={true}
                navigation={{
                  prevEl: prevRef.current,
                  nextEl: nextRef.current,
                }}
                pagination={{
                  el: paginationRef.current,
                  clickable: true,
                }}
                onBeforeInit={(swiper) => {
                  swiper.params.navigation.prevEl = prevRef.current;
                  swiper.params.navigation.nextEl = nextRef.current;
                  swiper.params.pagination.el = paginationRef.current;
                }}
                className="w-full h-full"
                breakpoints={{
                    0: {
                        slidesPerView: 1,
                    },
                    768: {
                        slidesPerView: 2,
                    },
                    1280: {
                        slidesPerView: 1,
                    },
                }}
              >
                {data.map((item, index) => (
                  <SwiperSlide key={index}>
                    <div className="px-[20px] md:px-[50px] pt-[35px] md:border-l h-full border-[#00000033] xl:border-none">
                        <h2 className="zen-dots text-[16px] xl:text-[24px] mt-[20px]">{t(item.title)}</h2>
                        <p className="ibm-plex text-[12px] xl:text-[14px] mt-[12px] text-[#000000B2]">{t(item.text)}</p>
                        <img src={item.img} alt="" className="mt-[40px]"/>
                    </div>  
                  </SwiperSlide>
                ))}
              </Swiper>
              <div className="flex items-center justify-between mt-auto border-t border-[#00000033] h-[48px]">
                <div ref={paginationRef} className="pl-[20px] md:pl-[50px] pb-[5px] !w-[200px]"></div>
                <div className="flex">
                    <button ref={prevRef} className="w-[124px] border-l hover:border hover:border-black transition-all h-[48px] border-[#00000033] flex items-center justify-center cursor-my"><img src={b1} alt="" /></button>
                    <button ref={nextRef} className="w-[124px] border-l hover:border hover:border-black transition-all h-[48px] border-[#00000033] flex items-center justify-center cursor-my"><img src={b2} alt="" /></button>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  );
}

export default WhatToTrade;
